import { Utils } from '@genial/utils';
import React, { SVGTextElementAttributes } from 'react';

export namespace FundraisingAnalysisChartYTickTypes {
  export interface Props extends SVGTextElementAttributes<any> {
    payload?: any;
  }
}

export const FundraisingAnalysisChartYTick: React.FC<FundraisingAnalysisChartYTickTypes.Props> = ({
  payload,
  ...props
}) => <text {...props}>{Utils.Mask.ScaleMoney(payload.value)}</text>;
